// extracted by mini-css-extract-plugin
export var children = "HeaderLinks-module--children--PU458";
export var link = "HeaderLinks-module--link--UvjyB";
export var list = "HeaderLinks-module--list--t74tD";
export var parent = "HeaderLinks-module--parent--utImH";
export var root = "HeaderLinks-module--root--GR+oL";